import { render, staticRenderFns } from "./purchase-intention-status.vue?vue&type=template&id=11b89db3&scoped=true"
import script from "./purchase-intention-status.vue?vue&type=script&lang=ts"
export * from "./purchase-intention-status.vue?vue&type=script&lang=ts"
import style0 from "./purchase-intention-status.vue?vue&type=style&index=0&id=11b89db3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b89db3",
  null
  
)

export default component.exports